import { render } from "./ViewMyAppointmentDialog.vue?vue&type=template&id=3b8470c2"
import script from "./ViewMyAppointmentDialog.vue?vue&type=script&lang=js"
export * from "./ViewMyAppointmentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__